import { render, staticRenderFns } from "./InvoiceDashboard.vue?vue&type=template&id=55a62f9e&scoped=true&"
import script from "./InvoiceDashboard.vue?vue&type=script&lang=js&"
export * from "./InvoiceDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDashboard.vue?vue&type=style&index=0&id=55a62f9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a62f9e",
  null
  
)

component.options.__file = "InvoiceDashboard.vue"
export default component.exports